import { createContext, ReactNode, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAccessToken } from 'utils/auth';
import { useReasonQuery } from '../query';
import { ReasonContextState } from '../types';

export const ReasonContext = createContext<ReasonContextState | undefined>(
  undefined
);

export const ReasonContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const { token } = useAccessToken();
  const { reasonId } = useParams();

  const { data, isLoading } = useReasonQuery(token, reasonId);

  const contextValue = useMemo(
    () => ({
      reason: data?.data,
      isError: !!(token && !data?.data),
      isLoading
    }),
    [token, data?.data, isLoading]
  );

  return (
    <ReasonContext.Provider value={contextValue}>
      {children}
    </ReasonContext.Provider>
  );
};
